import {REGIE_TIMEENTRIES_INDEX, REGIE_ARTICLEENTRIES_INDEX, REGIE_TIMEENTRIES_ADD, REGIE_ARTICLEENTRIES_ADD, REGIE_SAVE, REGIE_RESET, REGIE_SET_CUSTOMER, REGIE_SET_PROJECT, REGIE_SET_DESCRIPTION, REGIE_INDEX, REGIE_GET, REGIE_CURRENT, REGIE_GETWORKERS} from '../actions/regie'
import apiCall from '../../utils/api'

const state = {
  current: {
    timeentries: [],
    articleentries: [],
    id: null,
    customer: [],
    project: [],
    description: ''
  },
  workreports: [],
  workers: []
}

const getters = {
  [REGIE_TIMEENTRIES_INDEX]: (state, getters) => {
    return state.current.timeentries
  },
  [REGIE_ARTICLEENTRIES_INDEX]: (state, getters) => {
    return state.current.articleentries
  },
  [REGIE_INDEX]: (state) => {
    return state.workreports
  },
  [REGIE_CURRENT]: (state) => {
    return state.current
  },
  [REGIE_GETWORKERS]: (state) => {
    return state.workers
  }
}

const actions = {
  [REGIE_SAVE]: ({commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/workreport', method: 'POST', ...data}).then(resp => {
        // commit(TIMEENTRY_ADD, resp.data)
        resolve(resp.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [REGIE_INDEX]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/workreport', method: 'GET'}).then(resp => {
        commit(REGIE_INDEX, resp.data)
        resolve(resp.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [REGIE_GET]: ({commit, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/workreport/' + id, method: 'GET'}).then(resp => {
        resolve(resp.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [REGIE_GETWORKERS]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({url: 'api/workreport/workers', method: 'GET'}).then(resp => {
        commit(REGIE_GETWORKERS, resp.data)
        resolve(resp.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  [REGIE_TIMEENTRIES_ADD]: (state, resp) => {
    resp.workers.forEach((worker) => {
      state.current.timeentries = [...state.current.timeentries, {
        worker: worker,
        description: resp.description,
        date: resp.date,
        duration: resp.duration
      }]
    })
  },
  [REGIE_ARTICLEENTRIES_ADD]: (state, resp) => {
    state.articleentries = [...state.current.articleentries, resp]
  },
  [REGIE_RESET]: (state) => {
    state.current = {}
  },
  [REGIE_SET_CUSTOMER]: (state, resp) => {
    state.current.customer = resp
  },
  [REGIE_SET_PROJECT]: (state, resp) => {
    state.current.project = resp
  },
  [REGIE_SET_DESCRIPTION]: (state, resp) => {
    state.current.description = resp
  },
  [REGIE_INDEX]: (state, resp) => {
    state.workreports = resp
  },
  [REGIE_GET]: (state, resp) => {
    state.current = resp
  },
  [REGIE_GETWORKERS]: (state, resp) => {
    state.workers = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/regie.js